import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Burgermenu from '@/assets/burgerMenu.svg?react'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { AppRoutes } from '@/constants/appRoutes'
import type { ReportCheckData } from '@/store/api/Account/Account.types'
import { ESocialCheckStatus } from '@/store/api/Enterprise/Enterprise.types'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

interface BurgerMenuProps {
  data: ReportCheckData
  isLoading: boolean
  name: string
  onPressDownload: () => void
  initials: string
  hiddenDigitalReport?: boolean
}

export const BurgerMenu = ({
  data,
  isLoading,
  onPressDownload,
  name,
  hiddenDigitalReport = false,
}: BurgerMenuProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button className="flex items-center justify-center" variant="ghost">
            <Burgermenu color={SocialMirrorPalette.neutralColor} />
          </Button>
        </PopoverTrigger>

        <PopoverContent className="w-40 p-0 border-2 border-baseColorHighlight bg-baseColor rounded-md">
          <div className="flex flex-col justify-start items-start">
            <p className="w-full pl-2 py-2 border-b-2 border-baseColorHighlight">
              {name}
            </p>
            {!hiddenDigitalReport &&
              data.status === ESocialCheckStatus.Complete && (
                <Button
                  variant="ghost"
                  onClick={() => {
                    navigate(AppRoutes.digitalReport, {
                      state: { id: data._id, subjectId: data.subjectId },
                    })
                  }}
                  className="w-full rounded-none pl-2 justify-start"
                >
                  {t('dashboard.reports.view')}
                </Button>
              )}

            {data.pdf && (
              <>
                <Button
                  variant="ghost"
                  isLoading={isLoading}
                  onClick={() => {
                    onPressDownload()
                    setOpen(false)
                  }}
                  className="w-full rounded-none pl-2 justify-start cursor-pointer"
                >
                  {t('dashboard.reports.download')}
                </Button>
              </>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </>
  )
}
